import React from 'react';
import { IconCheck, IconArrowRight, IconStarFilled, IconHeadset, IconCrown, IconAlertCircle, IconRocket } from '@tabler/icons-react';

const ctaLabel = (mode) => (mode === 'paid' ? 'Contratar Agora' : 'Testar grátis por 7 dias');
const submitTextFor = (mode) => (mode === 'paid' ? 'Confirmar Contratação' : 'Começar teste grátis');

const PersonalPlans = ({ onSelectPlan, planFilter, mode = 'free' }) => {
  const plans = [];
  const isPaid = mode === 'paid';

  if (!planFilter || planFilter === 'starter') {
    plans.push(
      <div className="signup-plan-card" key="starter">
        <div className="signup-plan-card__header">
          <div className="signup-plan-card__name">Starter</div>
          <div className="signup-plan-card__subtitle">Ideal para começar seu projeto</div>
          <div className="signup-plan-card__price">
            <span className="signup-plan-card__price-currency">R$</span>
            <span className="signup-plan-card__price-value">347</span>
            <span className="signup-plan-card__price-period">/mês</span>
          </div>
        </div>

        <div className="signup-plan-card__body">
          <ul className="signup-plan-card__features">
            <li><IconCheck size={16} className="feature-check" /> 1 Agente Publicado</li>
            <li><IconCheck size={16} className="feature-check" /> Agentes Ilimitados para testes</li>
            <li><IconCheck size={16} className="feature-check" /> 1 Instância WhatsApp</li>
            <li><IconCheck size={16} className="feature-check" /> 2 Usuários</li>
            <li><IconCheck size={16} className="feature-check" /> 1000 clientes na base</li>
            <li><IconCheck size={16} className="feature-check" /> 1000 contatos no CRM</li>
            <li><IconCheck size={16} className="feature-check" /> 2000 mensagens/mês</li>
            <li><IconCheck size={16} className="feature-check" /> 2 Agendas</li>
            <li><IconCheck size={16} className="feature-check" /> Playground de testes</li>
          </ul>

          <button
            type="button"
            className="signup-plan-card__cta signup-plan-card__cta--success"
            onClick={(e) => {
              e.stopPropagation();
              onSelectPlan({
                usage_type: 1,
                plan_id: 7,
                account_type: '2',
                planName: 'Starter',
                planBadgeVariant: 'success',
                submitText: submitTextFor(mode),
                trialDays: isPaid ? 0 : 7,
                mode,
              });
            }}
          >
            {isPaid ? <IconRocket size={18} className="me-2" /> : null}
            {ctaLabel(mode)}
            <IconArrowRight size={18} className="ms-2" />
          </button>
          {!isPaid && <p className="signup-plan-card__no-card">Sem cartão de crédito</p>}
        </div>
      </div>
    );
  }

  if (!planFilter || planFilter === 'business') {
    plans.push(
      <div className="signup-plan-card signup-plan-card--recommended" key="business">
        <div className="signup-plan-card__ribbon">
          <IconStarFilled size={12} />
          Popular
        </div>
        <div className="signup-plan-card__header">
          <div className="signup-plan-card__name">Business</div>
          <div className="signup-plan-card__subtitle">Mais recursos para crescer</div>
          <div className="signup-plan-card__price">
            <span className="signup-plan-card__price-currency">R$</span>
            <span className="signup-plan-card__price-value">497</span>
            <span className="signup-plan-card__price-period">/mês</span>
          </div>
        </div>

        <div className="signup-plan-card__body">
          <ul className="signup-plan-card__features">
            <li><IconCheck size={16} className="feature-check" /> 1 Agente Publicado</li>
            <li><IconCheck size={16} className="feature-check" /> Agentes Ilimitados para testes</li>
            <li><IconCheck size={16} className="feature-check" /> 1 Instância WhatsApp</li>
            <li><IconCheck size={16} className="feature-check" /> 3 Usuários</li>
            <li><IconCheck size={16} className="feature-check" /> 3000 clientes na base</li>
            <li><IconCheck size={16} className="feature-check" /> 3000 contatos no CRM</li>
            <li><IconCheck size={16} className="feature-check" /> 5000 mensagens/mês</li>
            <li><IconCheck size={16} className="feature-check" /> 10 Agendas</li>
            <li><IconCheck size={16} className="feature-check" /> Playground de testes</li>
          </ul>

          <button
            type="button"
            className="signup-plan-card__cta signup-plan-card__cta--success"
            onClick={(e) => {
              e.stopPropagation();
              onSelectPlan({
                usage_type: 1,
                plan_id: 8,
                account_type: '2',
                planName: 'Business',
                planBadgeVariant: 'primary',
                submitText: submitTextFor(mode),
                trialDays: isPaid ? 0 : 7,
                mode,
              });
            }}
          >
            {isPaid ? <IconRocket size={18} className="me-2" /> : null}
            {ctaLabel(mode)}
            <IconArrowRight size={18} className="ms-2" />
          </button>
          {!isPaid && <p className="signup-plan-card__no-card">Sem cartão de crédito</p>}
        </div>
      </div>
    );
  }

  return <div className="signup-plan-cards">{plans}</div>;
};

const CommercialPlans = ({ onSelectPlan, planFilter, mode = 'free' }) => {
  const plans = [];
  const isPaid = mode === 'paid';

  if (!planFilter || planFilter === 'wl') {
    plans.push(
      <div className="signup-plan-card" key="wl">
        <div className="signup-plan-card__header">
          <div className="signup-plan-card__name">White Label</div>
          <div className="signup-plan-card__subtitle">Sua marca, sua plataforma</div>
          <div className="signup-plan-card__price">
            <span className="signup-plan-card__price-currency">R$</span>
            <span className="signup-plan-card__price-value">497</span>
            <span className="signup-plan-card__price-period">/mês</span>
          </div>
        </div>

        <div className="signup-plan-card__body">
          <ul className="signup-plan-card__features">
            <li><IconCheck size={16} className="feature-check" /> 3 Subcontas</li>
            <li><IconCheck size={16} className="feature-check" /> 1 Agente Publicado por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 1 Instância WhatsApp por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 2 Usuários por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 1000 clientes por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 1000 contatos por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 2000 mensagens/mês por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 2 Agendas por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> Suporte via WhatsApp</li>
          </ul>

          <button
            type="button"
            className="signup-plan-card__cta signup-plan-card__cta--success"
            onClick={(e) => {
              e.stopPropagation();
              onSelectPlan({
                usage_type: 2,
                plan_id: 9,
                account_type: '1',
                planName: 'White Label',
                planBadgeVariant: 'primary',
                submitText: submitTextFor(mode),
                trialDays: isPaid ? 0 : 7,
                mode,
              });
            }}
          >
            {isPaid ? <IconRocket size={18} className="me-2" /> : null}
            {ctaLabel(mode)}
            <IconArrowRight size={18} className="ms-2" />
          </button>
          {!isPaid && <p className="signup-plan-card__no-card">Sem cartão de crédito</p>}
        </div>
      </div>
    );
  }

  if (!planFilter || planFilter === 'wlplus') {
    plans.push(
      <div className="signup-plan-card signup-plan-card--recommended" key="wlplus">
        <div className="signup-plan-card__ribbon">
          <IconStarFilled size={12} />
          Popular
        </div>
        <div className="signup-plan-card__header">
          <div className="signup-plan-card__name">White Label Plus</div>
          <div className="signup-plan-card__subtitle">Escale seu negócio</div>
          <div className="signup-plan-card__price">
            <span className="signup-plan-card__price-currency">R$</span>
            <span className="signup-plan-card__price-value">897</span>
            <span className="signup-plan-card__price-period">/mês</span>
          </div>
        </div>

        <div className="signup-plan-card__body">
          <ul className="signup-plan-card__features">
            <li><IconCheck size={16} className="feature-check" /> 6 Subcontas</li>
            <li><IconCheck size={16} className="feature-check" /> 1 Agente Publicado por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 1 Instância WhatsApp por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 3 Usuários por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 2000 clientes por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 2000 contatos por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 4000 mensagens/mês por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 5 Agendas por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> Suporte via WhatsApp</li>
          </ul>

          <button
            type="button"
            className="signup-plan-card__cta signup-plan-card__cta--success"
            onClick={(e) => {
              e.stopPropagation();
              onSelectPlan({
                usage_type: 2,
                plan_id: 10,
                account_type: '1',
                planName: 'White Label Plus',
                planBadgeVariant: 'primary',
                submitText: submitTextFor(mode),
                trialDays: isPaid ? 0 : 7,
                mode,
              });
            }}
          >
            {isPaid ? <IconRocket size={18} className="me-2" /> : null}
            {ctaLabel(mode)}
            <IconArrowRight size={18} className="ms-2" />
          </button>
          {!isPaid && <p className="signup-plan-card__no-card">Sem cartão de crédito</p>}
        </div>
      </div>
    );
  }

  if (!planFilter || planFilter === 'wlpro') {
    plans.push(
      <div className="signup-plan-card signup-plan-card--recommended signup-plan-card--premium" key="wlpro">
        <div className="signup-plan-card__ribbon signup-plan-card__ribbon--premium">
          <IconCrown size={12} />
          Premium
        </div>
        <div className="signup-plan-card__header">
          <div className="signup-plan-card__name">White Label Pro</div>
          <div className="signup-plan-card__subtitle">Máximo desempenho e suporte</div>
          <div className="signup-plan-card__price">
            <span className="signup-plan-card__price-currency">R$</span>
            <span className="signup-plan-card__price-value">1.497</span>
            <span className="signup-plan-card__price-period">/mês</span>
          </div>
        </div>

        <div className="signup-plan-card__body">
          <div className="signup-plan-card__highlight">
            <IconHeadset size={18} />
            <span>Incluso 1h de consultoria por mês</span>
          </div>

          <ul className="signup-plan-card__features">
            <li><IconCheck size={16} className="feature-check" /> 10 Subcontas</li>
            <li><IconCheck size={16} className="feature-check" /> 1 Agente Publicado por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 1 Instância WhatsApp</li>
            <li><IconCheck size={16} className="feature-check" /> 5 Usuários por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 3000 clientes por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 3000 contatos por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 5000 mensagens/mês por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> 10 Agendas por subconta</li>
            <li><IconCheck size={16} className="feature-check" /> Suporte prioritário via WhatsApp</li>
          </ul>

          <button
            type="button"
            className="signup-plan-card__cta signup-plan-card__cta--premium"
            onClick={(e) => {
              e.stopPropagation();
              onSelectPlan({
                usage_type: 2,
                plan_id: 11,
                account_type: '1',
                planName: 'White Label Pro',
                planBadgeVariant: 'premium',
                submitText: submitTextFor(mode),
                trialDays: isPaid ? 0 : 7,
                mode,
              });
            }}
          >
            {isPaid ? <IconRocket size={18} className="me-2" /> : null}
            {ctaLabel(mode)}
            <IconArrowRight size={18} className="ms-2" />
          </button>
          {!isPaid && <p className="signup-plan-card__no-card">Sem cartão de crédito</p>}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="signup-plan-cards">{plans}</div>
      <div className="signup-plan-cards__notice">
        <IconAlertCircle size={16} />
        <span>Versão white label só é ativada após o pagamento do plano.</span>
      </div>
    </>
  );
};

const PlanSelector = ({ usageType, onSelectPlan, planFilter, mode = 'free' }) => {
  if (usageType === 'personal') {
    return <PersonalPlans onSelectPlan={onSelectPlan} planFilter={planFilter} mode={mode} />;
  }
  return <CommercialPlans onSelectPlan={onSelectPlan} planFilter={planFilter} mode={mode} />;
};

export default PlanSelector;
